var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "hasPermi",
              rawName: "v-hasPermi",
              value: ["platform:product:page:list"],
              expression: "['platform:product:page:list']",
            },
          ],
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", "label-position": "right" },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品搜索：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入商品ID、商品名称、关键字",
                          size: "small",
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSeachList($event)
                          },
                        },
                        model: {
                          value: _vm.keywords,
                          callback: function ($$v) {
                            _vm.keywords = $$v
                          },
                          expression: "keywords",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品分类：" } },
                    [
                      _c("el-cascader", {
                        ref: "cascader",
                        staticClass: "selWidth",
                        attrs: {
                          clearable: "",
                          options: _vm.merPlatProductClassify,
                          props: _vm.categoryProps,
                          size: "small",
                        },
                        on: { change: _vm.handleSeachList },
                        model: {
                          value: _vm.tableFrom.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "categoryId", $$v)
                          },
                          expression: "tableFrom.categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户类别：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "请选择",
                          },
                          on: { change: _vm.handleSeachList },
                          model: {
                            value: _vm.tableFrom.isSelf,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "isSelf", $$v)
                            },
                            expression: "tableFrom.isSelf",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "自营", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "非自营", value: 0 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户名称：" } },
                    [
                      _c("merchant-name", {
                        attrs: {
                          merIdChecked: _vm.tableFrom.merId,
                          onlySwitchOpen: true,
                        },
                        on: { getMerId: _vm.getMerId },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "会员商品：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "请选择",
                          },
                          on: { change: _vm.handleSeachList },
                          model: {
                            value: _vm.tableFrom.isPaidMember,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "isPaidMember", $$v)
                            },
                            expression: "tableFrom.isPaidMember",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "是", value: "true" },
                          }),
                          _c("el-option", {
                            attrs: { label: "否", value: "false" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "请选择",
                          },
                          on: { change: _vm.handleSeachList },
                          model: {
                            value: _vm.tableFrom.productType,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "productType", $$v)
                            },
                            expression: "tableFrom.productType",
                          },
                        },
                        _vm._l(_vm.productTypeList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["platform:product:page:list"],
                              expression: "['platform:product:page:list']",
                            },
                          ],
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleSeachList },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        { attrs: { size: "small" }, on: { click: _vm.reset } },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "div",
            { ref: "headerBox", staticClass: "clearfix" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "list-tabs mb5",
                  on: { "tab-click": _vm.handleSeachList },
                  model: {
                    value: _vm.tableFrom.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.tableFrom, "type", $$v)
                    },
                    expression: "tableFrom.type",
                  },
                },
                _vm._l(_vm.headeNum, function (item, index) {
                  return _c("el-tab-pane", {
                    key: index,
                    attrs: {
                      label: item.name + "(" + item.count + ")",
                      name: item.type.toString(),
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "acea-row mt5" },
            [
              _vm.tableFrom.type === _vm.ProductTypeEnum.OnSale &&
              _vm.checkPermi(["platform:product:force:down"])
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        disabled: !_vm.multipleSelection.length,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handlebatchOff()
                        },
                      },
                    },
                    [_vm._v("强制下架")]
                  )
                : _vm._e(),
              _vm.tableFrom.type === _vm.ProductTypeEnum.OnSale &&
              _vm.checkPermi(["platform:product:update"])
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        disabled: !_vm.multipleSelection.length,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleBatchRank($event)
                        },
                      },
                    },
                    [_vm._v("批量设置权重")]
                  )
                : _vm._e(),
              _vm.tableFrom.type === _vm.ProductTypeEnum.Audit &&
              _vm.checkPermi(["platform:product:batch:audit"])
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        disabled: !_vm.multipleSelection.length,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handlebatchAudit($event)
                        },
                      },
                    },
                    [_vm._v("批量审核")]
                  )
                : _vm._e(),
              _vm.tableFrom.type === _vm.ProductTypeEnum.Audit &&
              _vm.checkPermi(["platform:product:batch:price"])
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        disabled: !_vm.multipleSelection.length,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleBatchPrice($event)
                        },
                      },
                    },
                    [_vm._v("批量改价")]
                  )
                : _vm._e(),
              (Number(_vm.tableFrom.type) < 4 ||
                Number(_vm.tableFrom.type) === 6) &&
              _vm.checkPermi(["platform:product:batch:set:virtual:sales"])
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        disabled: !_vm.multipleSelection.length,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleBatchSales()
                        },
                      },
                    },
                    [_vm._v("增加初始销量")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20 tableSelection",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": true,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              Number(_vm.tableFrom.type) < 3 ||
              _vm.tableFrom.type === _vm.ProductTypeEnum.Audit
                ? _c("el-table-column", {
                    key: "2",
                    attrs: { type: "selection", width: "55" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { type: "expand", width: "40" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-table-expand",
                            attrs: { "label-position": "left", inline: "" },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "商户类别：" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("selfTypeFilter")(props.row.isSelf)
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "初始销量：" } },
                              [_c("span", [_vm._v(_vm._s(props.row.ficti))])]
                            ),
                            _vm.tableFrom.type == 7
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "拒绝原因：" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(props.row.reason)),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.checkedCities.includes("ID")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "ID",
                      width: "88",
                      "show-overflow-tooltip": "",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("商品图")
                ? _c("el-table-column", {
                    attrs: { label: "商品图", width: "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "demo-image__preview line-heightOne",
                                },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: scope.row.image,
                                      "preview-src-list": [scope.row.image],
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1508102206
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("商品名称")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "商品名称",
                      "min-width": "200",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "tags_name",
                                    class: "name" + scope.row.specType,
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.specType
                                          ? "[多规格]"
                                          : "[单规格]"
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(_vm._s(scope.row.name || "-") + " "),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      221850979
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("商户名称")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "merchantName",
                      label: "商户名称",
                      "min-width": "180",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("商品售价")
                ? _c("el-table-column", {
                    attrs: {
                      label: "商品售价",
                      prop: "price",
                      "min-width": "100",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("商品成本价") ||
              _vm.checkedCities.includes("商品成本")
                ? _c("el-table-column", {
                    attrs: {
                      label: "商品成本价",
                      prop: "cost",
                      "min-width": "100",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("销量")
                ? _c("el-table-column", {
                    attrs: { prop: "sales", label: "销量", "min-width": "100" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("库存")
                ? _c("el-table-column", {
                    attrs: { prop: "stock", label: "库存", "min-width": "70" },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("权重")
                ? _c("el-table-column", {
                    attrs: { label: "权重", prop: "rank", "min-width": "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-input-number", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  min: 0,
                                  max: 999999,
                                  size: "small",
                                  "controls-position": "right",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleUpdateRank(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.rank,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "rank", $$v)
                                  },
                                  expression: "scope.row.rank",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1339013131
                    ),
                  })
                : _vm._e(),
              _vm.tableFrom.type === "1"
                ? _c("el-table-column", {
                    attrs: {
                      label: "是否显示",
                      "min-width": "90",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "show-tag",
                                  class: scope.row.isShow
                                    ? "show-tag-on"
                                    : "show-tag-off",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleToggleShow(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(scope.row.isShow ? "显示" : "隐藏")
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      580460903
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("审核状态")
                ? _c("el-table-column", {
                    attrs: {
                      label: "审核状态",
                      "min-width": "80",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("auditStatusFilter")(
                                      scope.row.auditStatus
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4246894879
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "180px",
                  fixed: "right",
                  "scoped-slot": _vm.renderHeader,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["platform:product:info"],
                                expression: "['platform:product:info']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.handleAudit(scope.row.id, false)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _vm.tableFrom.type === "1"
                          ? [
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handlePreview(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("预览")]
                              ),
                            ]
                          : _vm._e(),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm.tableFrom.type === "6" &&
                        _vm.checkPermi(["platform:product:audit"])
                          ? [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAudit(scope.row.id, true)
                                    },
                                  },
                                },
                                [_vm._v("审核")]
                              ),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                            ]
                          : _vm._e(),
                        _c(
                          "el-dropdown",
                          {
                            attrs: { trigger: "click" },
                            on: {
                              command: function (cmd) {
                                return _vm.handleMoreCmd(cmd, scope.row)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "more-link" }, [
                              _vm._v("更多"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                Number(_vm.tableFrom.type) < 7 &&
                                _vm.checkPermi(["platform:product:update"])
                                  ? _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "edit" } },
                                      [_vm._v("编辑商品")]
                                    )
                                  : _vm._e(),
                                Number(_vm.tableFrom.type) < 7 &&
                                _vm.checkPermi(["platform:product:update"])
                                  ? _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "sales" } },
                                      [_vm._v("编辑销量")]
                                    )
                                  : _vm._e(),
                                Number(_vm.tableFrom.type) < 2 &&
                                _vm.checkPermi(["platform:product:force:down"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: { command: "off", divided: "" },
                                      },
                                      [_vm._v("强制下架")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.card_select_show,
              expression: "card_select_show",
            },
          ],
          staticClass: "card_abs",
        },
        [
          [
            _c(
              "div",
              { staticClass: "cell_ht" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { indeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function ($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll",
                    },
                  },
                  [_vm._v("全选")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.checkSave()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
            _c(
              "el-checkbox-group",
              {
                on: { change: _vm.handleCheckedCitiesChange },
                model: {
                  value: _vm.checkedCities,
                  callback: function ($$v) {
                    _vm.checkedCities = $$v
                  },
                  expression: "checkedCities",
                },
              },
              _vm._l(_vm.columnData, function (item) {
                return _c(
                  "el-checkbox",
                  {
                    key: item,
                    staticClass: "check_cell",
                    attrs: { label: item },
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              1
            ),
          ],
        ],
        2
      ),
      _c("info-from", {
        ref: "infoFrom",
        attrs: {
          componentKey: _vm.componentKey,
          "is-atud": _vm.isAtud,
          "is-show": _vm.isShow,
          isEdit: _vm.isEdit,
          productId: _vm.productId,
          fromType: "product",
          dialogVisibleInfoData: _vm.dialogVisibleInfo,
        },
        on: {
          subSuccess: _vm.subSuccess,
          onCloseInfo: _vm.onCloseInfo,
          saveSuccess: _vm.handleSaveSuccess,
        },
      }),
      _vm.previewVisible
        ? _c(
            "div",
            { staticClass: "preview-mask" },
            [
              _c("div", {
                staticClass: "bg",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.previewVisible = false
                  },
                },
              }),
              _vm.previewVisible
                ? _c("preview-box", {
                    ref: "previewBox",
                    attrs: { "product-id": _vm.previewProductId },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量设置权重",
            visible: _vm.rankDialogVisible,
            width: "540px",
            "before-close": _vm.handleRankClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.rankDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "rankForm",
              attrs: { model: _vm.rankForm, "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "权重：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: 999999,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.rankForm.rank,
                      callback: function ($$v) {
                        _vm.$set(_vm.rankForm, "rank", $$v)
                      },
                      expression: "rankForm.rank",
                    },
                  }),
                  _c(
                    "span",
                    { staticStyle: { color: "#909399", "font-size": "12px" } },
                    [_vm._v("数值越大排序越靠前，0 表示不设置权重")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rankDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.rankSubmitting },
                  on: { click: _vm.submitRank },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "增加初始销量",
            visible: _vm.dialogVisible,
            width: "540px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "demo-ruleForm",
              attrs: { model: _vm.formData, "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "增加初始销量：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 99999 },
                    model: {
                      value: _vm.formData.ficti,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formData,
                          "ficti",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "formData.ficti",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["platform:express:update"],
                      expression: "['platform:express:update']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("formData")
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("batch-audit", {
        ref: "refBatchAudit",
        attrs: { idList: _vm.checkedIds },
        on: { subBatchAuditSuccess: _vm.subBatchAuditSuccess },
      }),
      _c("batch-price", {
        ref: "refBatchPrice",
        attrs: { productIds: _vm.checkedIds, merId: _vm.selectedMerId },
        on: { success: _vm.subBatchAuditSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }